import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './MonitoringStatusPill.module.scss';
import { monitoringStatus } from '../../summary/monitoringSummary/constants';

const MonitoringStatusPill = (props) => {
    const pillStyles = (props.status !== monitoringStatus.noBreach) ? { backgroundColor: `#${props.colour}` } : {};
    return (
        <div className={ styles.statusPill } style={ pillStyles }> { props.status } </div>
    );
};

MonitoringStatusPill.propTypes = {
    status: PropTypes.string,
    colour: PropTypes.string
};

MonitoringStatusPill.defaultProps = {
    status: '',
    colour: ''
};

export default MonitoringStatusPill;
